import { render } from "./CrearUsuarioModal.vue?vue&type=template&id=2283f5c0"
import script from "./CrearUsuarioModal.vue?vue&type=script&lang=js"
export * from "./CrearUsuarioModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__